<template>
  <div>
    <v-dialog v-model="dialog" max-width="1200" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable persistent>
      <v-card class="white location-manager-dialog">
        <block v-if="loading"></block>

        <v-card-title class="d-flex justify-space-between align-center location-manager-header">
          <span>{{ title }}</span>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-tabs v-model="activeTab" background-color="transparent" grow class="location-manager-tabs">
          <v-tab href="#Bodegas">Bodegas</v-tab>
          <v-tab href="#Ubicaciones" :disabled="!selectedWarehouse">Ubicaciones</v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab" class="location-manager-content">
          <v-tab-item value="Bodegas">
            <v-row class="mt-2 px-4 px-sm-4">
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="warehouseSearch"
                  outlined
                  dense
                  label="Buscar bodega..."
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="location-grid-wrapper px-4 px-sm-4 pb-4">
              <DxDataGrid
                class="location-grid location-grid-warehouses"
                :data-source="filteredWarehouses"
                :show-borders="true"
                key-expr="ID_Warehouse"
              >
                <DxColumn :width="$vuetify.breakpoint.xsOnly ? 70 : 90" cell-template="open-warehouse" caption=""></DxColumn>
                <DxColumn data-field="ID_Warehouse" caption="ID Bodega"></DxColumn>
                <DxColumn data-field="Warehouse" caption="Nombre"></DxColumn>
                <DxColumn data-field="ID_Branch" caption="Sucursal"></DxColumn>

                <template #open-warehouse="{ data }">
                  <a href="#" @click.prevent.stop="selectWarehouse(data.data)">
                    <v-icon color="primary">mdi-eye</v-icon>
                  </a>
                </template>

                <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20]" />
                <DxPaging :page-size="10" />
              </DxDataGrid>
            </div>
          </v-tab-item>

          <v-tab-item value="Ubicaciones">
            <v-row class="mt-2 px-4 px-sm-4">
              <v-col cols="12" class="d-flex justify-space-between align-start flex-wrap location-summary" style="gap: 12px;">
                <div class="location-summary-info">
                  <v-btn icon class="location-back-button mb-2" @click="goToWarehouses">
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                  <h3 class="mb-1">{{ selectedWarehouse ? selectedWarehouse.Warehouse : "Ubicaciones" }}</h3>
                  <p class="mb-0" v-if="selectedWarehouse">ID Bodega: {{ selectedWarehouse.ID_Warehouse }}</p>
                </div>
                <div class="d-flex location-summary-actions" style="gap: 8px;">
                </div>
              </v-col>
            </v-row>

            <div class="px-4 px-sm-4 pb-4">
              <v-card outlined class="location-section-card mb-4">
                <div class="location-section-header">
                  <h4 class="mb-1">{{ isEditing ? "Editar ubicación" : "Crear nueva ubicación" }}</h4>
                </div>

                <v-row class="px-4 pb-4 location-form-row" align="center" no-gutters>
                  <v-col cols="12" md="4" class="location-form-field pr-md-3">
                    <v-text-field
                      v-model="form.LocationName"
                      outlined
                      dense
                      label="Nombre de ubicación"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3" class="location-form-field pr-md-3">
                    <v-text-field
                      v-model="form.LocationCode"
                      outlined
                      dense
                      label="Código"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2" class="location-form-switch-col pr-md-3">
                    <v-switch
                      v-model="form.IsActive"
                      inset
                      class="location-active-switch"
                      label="Activa"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="2" class="d-flex justify-start align-center location-form-actions" style="gap: 8px;">
                    <v-btn v-if="isEditing" class="btnclean" @click="resetForm">Cancelar</v-btn>
                    <v-btn class="btn-save" :disabled="!selectedWarehouse" @click="saveLocation">
                      {{ isEditing ? "Actualizar" : "Agregar ubicación" }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>

              <v-card outlined class="location-section-card">
                <div class="location-section-header">
                  <h4 class="mb-1">Buscar y administrar ubicaciones</h4>
                </div>

                <v-row class="px-4">
                  <v-col cols="12" md="8">
                    <v-text-field
                      v-model="locationSearch"
                      outlined
                      dense
                      label="Buscar ubicación..."
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <div class="location-grid-wrapper px-4 px-sm-4 pb-4">
                  <DxDataGrid
                    class="location-grid location-grid-locations"
                    :data-source="filteredLocations"
                    :show-borders="true"
                    key-expr="ID_Location"
                  >
                    <DxColumn
                      v-if="selectionMode"
                      :width="$vuetify.breakpoint.xsOnly ? 70 : 90"
                      cell-template="select-location"
                      caption=""
                    ></DxColumn>
                    <DxColumn :width="$vuetify.breakpoint.xsOnly ? 70 : 90" cell-template="edit-location" caption=""></DxColumn>
                    <DxColumn :width="$vuetify.breakpoint.xsOnly ? 70 : 90" cell-template="delete-location" caption=""></DxColumn>
                    <DxColumn data-field="LocationCode" caption="Código"></DxColumn>
                    <DxColumn data-field="LocationName" caption="Nombre"></DxColumn>
                    <DxColumn cell-template="status-location" caption="Estado"></DxColumn>
                    <DxColumn data-field="SystemDateUpdate" caption="Última modificación"></DxColumn>

                    <template #select-location="{ data }">
                      <a href="#" @click.prevent.stop="selectLocation(data.data)">
                        <v-icon color="primary">mdi-check-circle</v-icon>
                      </a>
                    </template>

                    <template #edit-location="{ data }">
                      <a href="#" @click.prevent.stop="editLocation(data.data)">
                        <v-icon color="warning">mdi-pencil</v-icon>
                      </a>
                    </template>

                    <template #delete-location="{ data }">
                      <a
                        href="#"
                        @click.prevent.stop="
                          toDelete = data.data.ID_Location;
                          showAlert(
                            'question',
                            'Eliminar ubicación',
                            '¿Está seguro que desea eliminar esta ubicación?',
                            'deleteLocation'
                          );
                        "
                      >
                        <v-icon color="error">mdi-delete</v-icon>
                      </a>
                    </template>

                    <template #status-location="{ data }">
                      <span>{{ Number(data.data.IsActive) === 1 ? "Activo" : "Desactivado" }}</span>
                    </template>

                    <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20]" />
                    <DxPaging :page-size="10" />
                  </DxDataGrid>
                </div>
              </v-card>
            </div>
          </v-tab-item>
        </v-tabs-items>

        <alerts
          v-if="alert.show"
          v-on:close_alert="closeAlert"
          v-on:accept_alert="acceptAlert"
          :properties="alert"
        ></alerts>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Alerts from "@/components/Alerts.vue";
import Block from "@/components/Block.vue";
import { DxDataGrid, DxColumn, DxPager, DxPaging } from "devextreme-vue/data-grid";

export default {
  name: "WarehouseLocationManagerDialog",
  components: {
    Alerts,
    Block,
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    initialWarehouseId: {
      type: [String, Number],
      default: null,
    },
    selectionMode: {
      type: Boolean,
      default: false,
    },
    autoSelectOnCreate: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Gestión de ubicaciones",
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      activeTab: "Bodegas",
      warehouses: [],
      locations: [],
      selectedWarehouse: null,
      warehouseSearch: "",
      locationSearch: "",
      toDelete: null,
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      form: {
        ID_Location: null,
        LocationName: "",
        LocationCode: "",
        IsActive: true,
      },
    };
  },
  computed: {
    filteredWarehouses() {
      const search = this.warehouseSearch.trim().toLowerCase();

      if (!search) {
        return this.warehouses;
      }

      return this.warehouses.filter((warehouse) =>
        `${warehouse.Warehouse || ""} ${warehouse.ID_Warehouse || ""}`.toLowerCase().includes(search)
      );
    },
    filteredLocations() {
      const search = this.locationSearch.trim().toLowerCase();

      if (!search) {
        return this.locations;
      }

      return this.locations.filter((location) =>
        `${location.LocationName || ""} ${location.LocationCode || ""}`.toLowerCase().includes(search)
      );
    },
    isEditing() {
      return !!this.form.ID_Location;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.dialog = value;

        if (value) {
          this.initialize();
        }
      },
    },
    dialog(value) {
      this.$emit("input", value);
    },
    initialWarehouseId(value) {
      if (value && this.dialog && this.warehouses.length) {
        const warehouse = this.warehouses.find(
          (current) => String(current.ID_Warehouse) === String(value)
        );

        if (warehouse) {
          this.selectWarehouse(warehouse);
        }
      }
    },
  },
  methods: {
    async initialize() {
      await this.loadWarehouses();

      if (this.initialWarehouseId) {
        const warehouse = this.warehouses.find(
          (current) => String(current.ID_Warehouse) === String(this.initialWarehouseId)
        );

        if (warehouse) {
          await this.selectWarehouse(warehouse);
          return;
        }
      }

      this.activeTab = "Bodegas";
    },
    async loadWarehouses() {
      this.loading = true;

      try {
        const user = JSON.parse(localStorage.getItem("user")) || {};
        const response = await this.$API.warehouse.getWarehousesByBusiness({
          business: user.businessid || "",
        });
        this.warehouses = (response || []).filter(
          (warehouse) => Number(warehouse.isDeleted || 0) !== 1
        );
      } finally {
        this.loading = false;
      }
    },
    async loadLocations() {
      if (!this.selectedWarehouse) {
        this.locations = [];
        return;
      }

      this.loading = true;

      try {
        this.locations = await this.$API.inventoryWarehouseLocations.getByWarehouse({
          warehouseId: this.selectedWarehouse.ID_Warehouse,
          includeInactive: 1,
        });
      } finally {
        this.loading = false;
      }
    },
    async selectWarehouse(warehouse) {
      this.selectedWarehouse = warehouse;
      this.activeTab = "Ubicaciones";
      this.resetForm();
      await this.loadLocations();
    },
    goToWarehouses() {
      this.activeTab = "Bodegas";
    },
    resetForm() {
      this.form = {
        ID_Location: null,
        LocationName: "",
        LocationCode: "",
        IsActive: true,
      };
    },
    editLocation(location) {
      this.form = {
        ID_Location: location.ID_Location,
        LocationName: location.LocationName,
        LocationCode: location.LocationCode,
        IsActive: Number(location.IsActive) === 1,
      };
    },
    normalizeLocation(location) {
      return {
        ...location,
        ID_location: location.ID_Location,
        location: location.LocationName,
      };
    },
    async saveLocation() {
      if (!this.selectedWarehouse) {
        this.showAlert("warning", "Ubicaciones", "Seleccione una bodega.");
        return;
      }

      if (!this.form.LocationName.trim() || !this.form.LocationCode.trim()) {
        this.showAlert("warning", "Ubicaciones", "Debe completar el nombre y el código.");
        return;
      }

      this.loading = true;

      try {
        const user = JSON.parse(localStorage.getItem("user")) || {};
        const payload = {
          ID_Warehouse: this.selectedWarehouse.ID_Warehouse,
          LocationName: this.form.LocationName.trim(),
          LocationCode: this.form.LocationCode.trim(),
          IsActive: this.form.IsActive ? 1 : 0,
          user: user.id,
        };

        let response = null;

        if (this.isEditing) {
          response = await this.$API.inventoryWarehouseLocations.update(this.form.ID_Location, payload);
          this.showAlert("success", "Ubicaciones", "La ubicación se actualizó correctamente.");
        } else {
          response = await this.$API.inventoryWarehouseLocations.create(payload);
          this.showAlert("success", "Ubicaciones", "La ubicación se creó correctamente.");
        }

        await this.loadLocations();

        const detail = response?.detail ? this.normalizeLocation(response.detail) : null;
        const shouldAutoSelect = !this.isEditing && this.autoSelectOnCreate && detail && this.selectionMode;
        const updatedWarehouseId = this.selectedWarehouse ? this.selectedWarehouse.ID_Warehouse : null;

        this.$emit("locations-updated", {
          warehouseId: updatedWarehouseId,
          location: detail,
        });

        this.resetForm();

        if (shouldAutoSelect) {
          this.$emit("location-selected", detail);
        }
      } catch (error) {
        console.log(error);
        this.showAlert("warning", "Ubicaciones", error || "No se pudo guardar la ubicación.");
      } finally {
        this.loading = false;
      }
    },
    async destroyLocation() {
      this.loading = true;

      try {
        const user = JSON.parse(localStorage.getItem("user")) || {};
        await this.$API.inventoryWarehouseLocations.delete(this.toDelete, { user: user.id });
        this.showAlert("success", "Ubicaciones", "La ubicación se eliminó correctamente.");
        await this.loadLocations();
        this.$emit("locations-updated", {
          warehouseId: this.selectedWarehouse ? this.selectedWarehouse.ID_Warehouse : null,
          location: null,
        });
        this.resetForm();
      } catch (error) {
        console.log(error);
        this.showAlert("warning", "Ubicaciones", error || "No se pudo eliminar la ubicación.");
      } finally {
        this.loading = false;
      }
    },
    selectLocation(location) {
      this.$emit("location-selected", this.normalizeLocation(location));
      this.closeDialog();
    },
    emitSelectionFromCurrentForm() {
      if (!this.form.ID_Location) {
        return;
      }

      const location = this.locations.find(
        (current) => Number(current.ID_Location) === Number(this.form.ID_Location)
      );

      if (location) {
        this.selectLocation(location);
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    closeAlert() {
      this.alert.show = false;
    },
    acceptAlert() {
      this.alert.show = false;

      if (this.alert.options === "deleteLocation") {
        this.destroyLocation();
      }
    },
    showAlert(type, header, body, options = null) {
      this.alert.type = type || "danger";
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options;
    },
  },
};
</script>

<style scoped>
.location-manager-dialog {
  padding: 16px;
}

.location-manager-header {
  padding: 8px 8px 16px;
}

.location-manager-tabs {
  padding: 0 8px;
}

.location-manager-content {
  padding-top: 4px;
}

.location-grid-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.location-summary {
  margin-bottom: 16px;
}

.location-summary-info {
  display: flex;
  flex-direction: column;
}

.location-back-button {
  align-self: flex-start;
  margin-left: -8px;
}

.location-section-card {
  border-radius: 14px;
  border-color: #d9e1ec !important;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
}

.location-section-header {
  padding: 18px 20px 8px;
}

.location-section-header h4 {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
}

.location-section-header p {
  color: #6b7280;
  font-size: 13px;
}

.location-form-row {
  row-gap: 12px;
}

.location-form-field,
.location-form-switch-col,
.location-form-actions {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.location-form-field :deep(.v-input),
.location-form-switch-col :deep(.v-input) {
  margin-top: 0;
}

.location-form-field :deep(.v-text-field__details) {
  display: none;
}

.location-form-switch-col {
  display: flex;
  align-items: center;
  min-height: 56px;
}

.location-active-switch {
  margin: 0 !important;
  padding: 0 !important;
}

.location-active-switch :deep(.v-input__control) {
  min-height: 56px;
  display: flex;
  justify-content: center;
}

.location-active-switch :deep(.v-input__slot) {
  margin: 0 !important;
}

.location-form-actions {
  min-height: 56px;
}

.location-grid {
  min-width: 100%;
}

.location-grid-warehouses {
  min-width: 640px;
}

.location-grid-locations {
  min-width: 760px;
}

@media (max-width: 600px) {
  .location-manager-dialog {
    padding: 8px;
  }

  .location-manager-header {
    padding: 4px 4px 12px;
  }

  .location-manager-tabs {
    padding: 0;
  }

  .location-summary {
    align-items: flex-start !important;
  }

  .location-summary-actions {
    width: 100%;
    flex-direction: column;
  }

  .location-summary-actions .v-btn {
    width: 100%;
    margin: 0 !important;
  }

  .location-form-actions {
    justify-content: stretch !important;
    flex-direction: column;
  }

  .location-form-actions .v-btn {
    width: 100%;
    margin: 0 !important;
  }

  .location-grid-wrapper {
    padding-bottom: 12px !important;
  }

  .location-grid-warehouses {
    min-width: 720px;
  }

  .location-grid-locations {
    min-width: 860px;
  }
}
</style>
